import $ from 'jquery';
window.jQuery = $;
require('slick-carousel');

export default {
  init() {
    // JavaScript to be fired on all pages

    // Mobile Navigation Toggle
    $('#nav-toggle').click(e => {
      $('#nav-primary').toggleClass('is-active');
    });

    // Image carousel block
    $('.block-images .slider').slick({
      arrows: false
    });

    // Consultation Button
    $('.consultation-start, a[href="#consult"]').click(() => {
      $('#consultation').addClass('is-active');
    });

    // Modal Close
    $('.modal-close').click(e => {
      console.log('clicked close');
      $('#consultation').removeClass('is-active');
    });

    // Services & Custom Content Carousel
    $('.cards.layout-carousel').not('.cards-testimonials').slick({
      slidesToShow: 5,
      centerMode: true,
      centerPadding: '5vw',
      autoplay: true,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 720,
          settings: {
            slidesToShow: 1,
            centerPadding: '10vw',
          }
        }
      ]
    });

    // Testimonials Carousel
    $('.cards.layout-carousel.cards-testimonials').slick({
      slidesToShow: 4,
      centerMode: true,
      centerPadding: '5vw',
      autoplay: true,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 720,
          settings: {
            slidesToShow: 1,
            centerPadding: '10vw',
          }
        }
      ]
    });

    // Services Gallery Photo Modal
    let galleryActive = '';
    let galleryNavPrev = '';
    let galleryNavNext = '';
    $('.gallery-enlarge').click(e => {
      $('#modal-photo').addClass('is-active');
      const $this = $(e.currentTarget);
      galleryActive = parseInt($this.data('id'));
      galleryNavPrev = `#gallery-${galleryActive - 1}`;
      galleryNavNext = `#gallery-${galleryActive + 1}`;
      const image = $this.data('image');
      $('#gallery-photo').attr('src', image);
    });

    // TODO: Work out navigation between gallery photos
    // // Services gallery Previous/Next
    // $('.gallery-nav span').click(e => {
    //   const $this = $(e.currentTarget);
    //   let galleryImage = '';
    //   if($(e.currentTarget).hasClass('previous')) {
    //     galleryImage = $(galleryNavPrev).data('image');
    //   } else {
    //     galleryImage = $(galleryNavNext).data('image');
    //   }
    //   $('#gallery-photo').attr('src', galleryImage);
    //   galleryActive = parseInt($this.data('id'));
    //   galleryNavPrev = `#gallery-${galleryActive - 1}`;
    //   galleryNavNext = `#gallery-${galleryActive + 1}`;
    // });

    // Close Modal Window
    $('.modal-close').click(e => {
      $('.modal').removeClass('is-active');
      $('#portfolio-modal-content').html('');
      $('.portfolio-gallery').slick('unslick');
    });

    function portfolioOpen(e) {
      const $this = $(e.currentTarget);
      const $id = $this.data('id');
      const $content = $this.next('.portfolio-modal').find('.portfolio-modal-data').clone();
      $('#modal-portfolio').addClass('is-active');
      $('#portfolio-modal-content').append($content);
      $('.portfolio-gallery').slick({
        prevArrow: '<button type="button" class="arrow prev"><span class="icon icon-arrow"></span></button>',
        nextArrow: '<button type="button" class="arrow next"><span class="icon icon-arrow"></span></button>',
      });
    }

    // Portfolio Modal
    $('.portfolio').click(e => {
      portfolioOpen(e);
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after init JS is fired

    // Add class to .header when scrolled one pixel from the top
    window.addEventListener('scroll', () => {
      const scrolled = window.scrollY;
      const header = document.querySelector('header');

      if (scrolled > 0) {
        header.classList.add('is-scroll');
      } else {
        header.classList.remove('is-scroll');
      }
    });

    // Parallax scrolling
    const parallaxElements = document.querySelectorAll('.parallax');

    parallaxElements.forEach((element) => {
      const img = element;
      const imgParent = element.parentNode;

      const parallaxImg = () => {
        const speed = img.dataset.speed;
        const imgY = imgParent.offsetTop;
        const winY = window.scrollY;
        const winH = window.innerHeight;
        const parentH = imgParent.clientHeight;
        const winBottom = winY + winH;

        if (winBottom > imgY && winY < imgY + parentH) {
          const imgBottom = (winBottom - imgY) * speed;
          const imgTop = winH + parentH;
          const imgPercent = (imgBottom / imgTop) * 100 + (50 - speed * 50);

          img.style.top = `${imgPercent}%`;
          img.style.transform = `translate(-50%, -${imgPercent}%)`;
        }
      };

      document.addEventListener('scroll', parallaxImg);
      document.addEventListener('DOMContentLoaded', parallaxImg);

      window.addEventListener('load', () => {
        parallaxImg();
        img.classList.add('is-loaded');
      });
    });

    // Footer Call to Action Form
    $('#consult-form-pre').on('submit', (e) => {
      e.preventDefault();
      const $this = $(e.currentTarget);
      const nameFirst = $this.find('input.name.first').val();
      const nameLast = $this.find('input.name.last').val();
      const emailAddress = $this.find('input.email').val();
      if(nameFirst.length > 0 && nameLast.length > 0 && emailAddress.length > 0) {
        $('#consultation-start').trigger('click');
        $('#input_1_5_3').val(nameFirst);
        $('#input_1_5_6').val(nameLast);
        $('#input_1_6').val(emailAddress);
        $('#input_1_7').focus();
      } else {
        alert('Please fill out everything to schedule a consultation.');
      }
    });

    // Knowledge Base Toggle
    $('.article > h3').click(e => {
      $(e.currentTarget).parent('.article').toggleClass('is-active');
    });

    // Portfolio Modal Trigger
    let allParams = new URLSearchParams(window.location.search);
    let projectOpen = allParams.get('view-casestudy');
    $(`#portfolio-${projectOpen}`).trigger('click');
  },
};
